import { useEffect } from "react";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Pillars } from "@/components/Pillars";
import { DiscoveryFeature } from "@/components/DiscoveryFeature";
import { MeetStaci } from "@/components/MeetStaci";
import { Consultations } from "@/components/Consultations";
import { NewsletterSection } from "@/components/NewsletterSection";
import { HowItWorks } from "@/components/HowItWorks";
import { JourneyPreview } from "@/components/JourneyPreview";
import { ResourcesPromo } from "@/components/ResourcesPromo";
import { Community } from "@/components/Community";
import { FAQ } from "@/components/FAQ";
import { FinalInvitation } from "@/components/FinalInvitation";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  useEffect(() => {
    document.title = "Rooted Healing by Staci Freed | Holistic Wellness for Women & Mothers";
    if (window.location.hash) {
      const t = setTimeout(() => scrollToId(window.location.hash), 250);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <main>
      <Hero />
      <Marquee />
      <Pillars />
      <DiscoveryFeature />
      <MeetStaci />
      <Consultations />
      <NewsletterSection />
      <HowItWorks />
      <JourneyPreview />
      <ResourcesPromo />
      <Community />
      <FAQ />
      <FinalInvitation />
    </main>
  );
}
